class ModalBundleDialog extends ModalDialog {
  constructor() {
    super();
    this.positionModal = this.positionModal.bind(this);
    this.debouncedPositionModal = debounce(this.positionModal, 100);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
    this.handleEscapeKey = this.handleEscapeKey.bind(this);
    document.addEventListener("modalClosed", this.hide.bind(this));
  }
  connectedCallback() {
    // Skip ModalDialog.connectedCallback body-move when inside a promo popup dialog,
    // otherwise the element gets moved to document.body and out of the <dialog> context
    if (!this.closest('.promo-bundle-popup')) {
      super.connectedCallback();
    }
    this.addEventListener('openModal', this.positionModal);
    window.addEventListener('resize', this.debouncedPositionModal);
  }
  disconnectedCallback() {
    window.removeEventListener('resize', this.debouncedPositionModal);
  }

  show(opener) {
    if (this.hasAttribute("open")) this.hide();

    this.openedBy = opener;
    this.querySelector(".template-popup")?.loadContent();
    this.style.display = ''; // Clear any inline display:none from previous close
    this.setAttribute("open", "");
    this.positionModal({ detail: { opener } });

    setTimeout(() => {
      document.body.addEventListener("click", this.handleOutsideClick);
      document.body.addEventListener("keyup", this.handleEscapeKey);
    }, 300);
  }

  hide() {
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    document.body.removeEventListener("click", this.handleOutsideClick);
    document.body.removeEventListener("keyup", this.handleEscapeKey);

    // Move back outside [data-bundle-content] so reset() innerHTML replacement won't destroy it
    if (this.classList.contains('promo-bundle-popup__flavor-modal')) {
      const bundleWrapper = this.closest('.product-bundle.bundle-modal-version') || this.closest('[data-bundle-content]')?.parentElement;
      if (bundleWrapper) {
        bundleWrapper.insertAdjacentElement('afterend', this);
      }
    }
  }

  handleOutsideClick(e) {
    if (!this.contains(e.target) && this.hasAttribute("open")) this.hide();
  }

  handleEscapeKey(e) {
    if (e.key === 'Escape' && this.hasAttribute("open")) this.hide();
  }

  positionModal(event) {
    const opener = event?.detail?.opener || this.openedBy;
    if (!opener) {
      console.error("Opener is not defined");
      return;
    }

    const currentData = opener.getAttribute('data-current');
    const parentElement = opener.closest(`.product-bundle__product.ed-product-bundle__product[data-current="${currentData}"]`);

    if (parentElement) {
      setProductCheckedState(parentElement, this);
      if (this.classList.contains('promo-bundle-popup__flavor-modal')) {
        // Move the modal to appear right after the clicked bundle item
        parentElement.insertAdjacentElement('afterend', this);
        requestAnimationFrame(() => {
          this.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        });
        return;
      }
      const targetRect = parentElement.getBoundingClientRect();
      this.style.position = 'absolute';
      this.style.top = `${targetRect.bottom + window.scrollY}px`;
      this.style.left = `${targetRect.left + window.scrollX}px`;
      this.style.width = `${targetRect.width}px`; // Set width to match parent element
    }
  }
}

customElements.define("modal-bundle-dialog", ModalBundleDialog);

// Debounce-Funktion
function debounce(func, wait) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
}

function setProductCheckedState(productModal, templatePopup) {
  const variantId = productModal.getAttribute('data-product-variant-id');
  const products = templatePopup.querySelectorAll('.ed-product-bundle__product');

  products.forEach(product => product.removeAttribute('data-checked'));

  templatePopup.querySelector(`.ed-product-bundle__product[data-id="${variantId}"]`)?.setAttribute('data-checked', '');
}